// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22vUw","content":"styles_content__18di1"};